const context = require.context("./", true, /^.*\.html$/);
const keys = context.keys();

angular.module("app")
	.run([
	"$templateCache",
	"ENV",
	function ($templateCache, ENV) {
		keys
			.forEach(k => {
				const newKey = k.replace("./", `${ENV.COMMON_DIRECTIVES_URL}common/`);
				$templateCache.put(newKey, context(k).default);
			});
	}
]);
